var firebaseConfig = {
    apiKey: "AIzaSyAUZSi7lvHASRhC3Bc8Zn_sfg5bN69nnoM",
    authDomain: "doctors-portal-tp.firebaseapp.com",
    databaseURL: "https://doctors-portal-tp.firebaseio.com",
    projectId: "doctors-portal-tp",
    storageBucket: "doctors-portal-tp.appspot.com",
    messagingSenderId: "111487526078",
    appId: "1:111487526078:web:b1dcfc726dd74f0f18aaef"
};
export default firebaseConfig;